export default __webpack_public_path__ + "static/media/art-pro-brw-poster-1.11abc7fb.jpg";